import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Overlay from '../../../forms/_common/Overlay';
import FormErrors from '../../../forms/_common/FormErrors';
import RequestError from '../../../forms/_common/RequestError';
import ErrorMessage from '../../../forms/_common/ErrorMessage';
import FormTemplate from '../../../dialogs_common/SetupTemplate';
import PrimaryButton from '../../../components_setup/PrimarySetupButton';
import { useQueryMutation } from '../../../../hooks/@lore/query-connect';
import SelectableIconCard from '../activities/SelectableIconCard';
import {
  CheckIcon,
  ClipboardDocumentListIcon,
  HeartIcon,
  UserIcon,
  UsersIcon,
  WrenchIcon
} from '@heroicons/react/24/outline';
import Value from '../educator-value/Value';

Form.propTypes = {
  user: PropTypes.object.isRequired,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  onSkip: PropTypes.func
};

export default function Form(props) {
  const {
    user,
    navigation,
    onNext,
    onPrevious,
    onSkip
  } = props;

  const [data, setData] = useState({
    // name: user.data.name || ''
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('currentUser.updateSingleton', user);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      onNext(data);
    }
  }, [success]);

  function onSubmit() {
    // mutation.mutate(data);
    onNext(data);
  }

  return (
    <div className="my-auto">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          // name: [validators.isRequired]
        }}>
          {({ errors, hasError }) => {
            return (
              <FormTemplate
                onPrevious={onPrevious}
                navigation={navigation}
                // title={(
                //   <>
                //     We're excited you're here! Your community has partners ready to help bring
                //     your ideas to life.
                //   </>
                // )}
                // subtitle="Together we'll:"
                alert={error ? (
                  <RequestError request={request} v2={true} />
                ) : showErrors ? (
                  <ErrorMessage v2={true}>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : null}
                body={(
                  <>
                    <div className="flex flex-col">
                      <div className="mb-6">
                        <h5 className="text-3xl text-cs-gray-900 font-semibold text-left mb-8">
                          Exciting news! Your site is active and your community is beginning
                          to grow.
                        </h5>
                        <h6 className="font-normal mt-2 text-cs-gray-800 text-left text-lg mb-2">
                          While there may be just a few partners nearby for now, you can start
                          building connections locally and explore our vibrant national network
                          virtually. Together we'll:
                        </h6>
                        <div className="space-y-2 mt-4">
                          <Value
                            icon={WrenchIcon}
                            title={(
                              <>
                                1. <span className="font-semibold">Build your profile</span> so partners can connect with you and your students
                              </>
                            )}
                          />
                          <Value
                            icon={ClipboardDocumentListIcon}
                            title={(
                              <>
                                2. <span className="font-semibold">Shape your ideas into projects</span> with step-by-step guidance
                              </>
                            )}
                          />
                          <Value
                            icon={UsersIcon}
                            title={(
                              <>
                                3. <span className="font-semibold">Tap into resources and partners</span> who can support your work
                              </>
                            )}
                          />
                        </div>
                        {/*<ol className="list-decimal list-inside text-cs-gray-800 text-lg">*/}
                        {/*  <li>*/}
                        {/*    Build your profile so partners can connect with you and your students*/}
                        {/*  </li>*/}
                        {/*  <li>*/}
                        {/*    Shape your ideas into projects with step-by-step guidance*/}
                        {/*  </li>*/}
                        {/*  <li>*/}
                        {/*    Tap into resources and partners who can support your work*/}
                        {/*  </li>*/}
                        {/*</ol>*/}
                      </div>
                      {/*<div className="space-y-2">*/}
                      {/*  <SelectableIconCard*/}
                      {/*    icon={CheckIcon}*/}
                      {/*    name="1. Build your profile so partners can connect with you and your students"*/}
                      {/*    // description="Knowledge, experience, and expertise areas you know"*/}
                      {/*  />*/}
                      {/*  <SelectableIconCard*/}
                      {/*    icon={CheckIcon}*/}
                      {/*    name="2. Shape your ideas into projects with step-by-step guidance"*/}
                      {/*    // description="Knowledge, experience, and expertise areas you know"*/}
                      {/*  />*/}
                      {/*  <SelectableIconCard*/}
                      {/*    icon={CheckIcon}*/}
                      {/*    name="3. Tap into resources and partners who can support your work"*/}
                      {/*    // description="Knowledge, experience, and expertise areas you know"*/}
                      {/*  />*/}
                      {/*</div>*/}
                    </div>
                  </>
                )}
                footer={(
                  <>
                    {/*<div className="text-cs-orange-500 underline cursor-pointer mt-6 sm:mt-0 mr-0 sm:mr-12" onClick={onSkip}>*/}
                    {/*  Skip this step*/}
                    {/*</div>*/}
                    <PrimaryButton disabled={hasError} onClick={() => hasError ? setShowErrors(true) : onSubmit()}>
                      Let's go!
                    </PrimaryButton>
                  </>
                )}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </div>
  );
};
